// Deterministic avatar tint + initials for a customer, so each customer keeps a
// stable colour across the list row and the profile header.

export type AvatarTint = { bg: string; fg: string };

const AVATAR_TINTS: AvatarTint[] = [
  { bg: "#EEF1F8", fg: "#2f4170" },
  { bg: "#FBF1DD", fg: "#9A6B12" },
  { bg: "#E7F3EC", fg: "#15803D" },
  { bg: "#F3ECF8", fg: "#6D3E8E" },
  { bg: "#FBE9E9", fg: "#A1564F" },
  { bg: "#E9F0FE", fg: "#2563EB" },
];

export function tintFor(name: string): AvatarTint {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) {
    hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  }
  return AVATAR_TINTS[hash % AVATAR_TINTS.length];
}

export function initialsOf(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "?";
  if (words.length === 1) return words[0].charAt(0).toUpperCase();
  return (words[0].charAt(0) + words[words.length - 1].charAt(0)).toUpperCase();
}
